import React, { useEffect } from 'react';
import { Card } from 'antd';
import { FileExploreProvider } from 'hooks/useFileExplore';
import NavigationPane from './NavigationPane';
import ListPane from './ListPane';

/**
 * 파일 전송 페이지
 * @returns {React.ReactNode}
 */
export default function FileExplorer() {
  useEffect(() => {
    // eslint-disable-next-line consistent-return
    const handleBeforeUnload = (e) => {
      if (window.uploadManager && window.uploadManager.hasActiveUploads?.()) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };
    // 페이지 이탈 경고 방지를 위한 beforeunload 이벤트 핸들러
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <FileExploreProvider>
      <Card
        className="fileExplore"
        style={{ height: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column' }}
      >
        <div style={{ display: 'flex', height: '100%', overflow: 'hidden' }}>
          <div
            className="fileExplore-navigation"
            style={{ width: 240, height: '100%', overflow: 'hidden' }}
          >
            <NavigationPane />
          </div>
          <div className="fileExplore-list" style={{ flex: 1, height: '100%', overflow: 'hidden' }}>
            <ListPane />
          </div>
        </div>
      </Card>
    </FileExploreProvider>
  );
}
